import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { arrayTranslate, translate } from 'containers/services/translate';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isNil } from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { BootstrapInput } from 'containers/UploadDocuments/styles';
import {
  INCOME_CERTIFICATE,
  EMPTY_DOCUMENT_CERTIFICATE,
} from 'containers/data-structure';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { DOCUMENT_TYPES } from 'constants/global';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { incomeCertificateValidator } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/form-validations';
import { displayErrorText } from 'containers/services/validateForm';
import { VictimType } from 'typings/globalTypes';
import { getProposedIncomeByProfession } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { Listings } from 'containers/AppContainer/typings';
export interface VictimCertificateFormProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  sagisVictimInfo: any;
  requestCreateIncomeCertificate?: Function;
  isManager: Boolean;
  setDocumentId: Function;
  documentId: any;
  claimId: number;
  claimNumber: string;
  incomeCertificates: any;
  setIncomeCertificates: Function;
  victim: VictimType;
  handleChange: Function;
  setDocument: Function;
  index: number;
  lossDate: Date;
  listings: Listings;
}

const VictimCertificateForm: React.FC<VictimCertificateFormProps> = (
  props,
): JSX.Element => {
  const incomeCertificateValidation = {
    ...incomeCertificateValidator(
      props.incomeCertificates[(props.victim?.id as unknown) as number],
    ),
  };
  const [documentType, setDocumentType] = React.useState(null);
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  useEffect(() => {
    if (featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)) {
      const proposedIncome = getProposedIncomeByProfession(
        get(props.listings, 'allocationConfig', []),
        props.victim,
        props.lossDate,
      );
      if (
        !isNil(proposedIncome) &&
        props.incomeCertificates[(props.victim.id as unknown) as number] &&
        documentType === DOCUMENT_TYPES.SCHOOLING_CERTIFICATE
      ) {
        props.setIncomeCertificates((prev: any) => {
          return {
            ...prev,
            [(props.victim.id as unknown) as number]: {
              ...prev[(props.victim.id as unknown) as number],
              [INCOME_CERTIFICATE.INCOME]: proposedIncome,
            },
          };
        });
      }
    }
  }, [
    props.victim,
    props.lossDate,
    props.victim.id,
    !!props.incomeCertificates[(props.victim?.id as unknown) as number]
      ?.victimId,
    documentType,
  ]);

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);

  const { message } =
    displayErrorText(
      incomeCertificateValidation,
      translateArrayErrorMessages(incomeCertificateValidation, true),
    ) || {};

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      key={props.victim.id}
      alignItems={'center'}
    >
      <Grid item xs={3} className="select-victims">
        <FormControlLabel
          control={
            <Checkbox
              checked={
                !!props.incomeCertificates[
                  (props.victim?.id as unknown) as number
                ]?.victimId
              }
              name={INCOME_CERTIFICATE.VICTIM_ID}
              color="primary"
              onChange={props.handleChange(props.victim)}
            />
          }
          label={
            featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
              ? `${get(
                  getVictimFromSagisInfo(
                    get(props.victim, 'victimKey'),
                    props.sagisVictimInfo,
                  ),
                  'victimFirstName',
                  '',
                )} ${get(
                  getVictimFromSagisInfo(
                    get(props.victim, 'victimKey'),
                    props.sagisVictimInfo,
                  ),
                  'victimLastName',
                  '',
                )}`
              : `${props.victim.firstName} ${props.victim.lastName}`
          }
        />
      </Grid>

      {!!props.incomeCertificates[(props.victim?.id as unknown) as number] && (
        <React.Fragment>
          <Grid item xs={3}>
            <FormControl fullWidth>
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-procedure"
              >
                {translate({ ...messages.typeDocument }, props)}
              </InputLabel>
              <Select
                fullWidth
                value={documentType}
                onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                  if (
                    !isNil(
                      get(
                        get(
                          props.incomeCertificates,
                          [(props.victim.id as unknown) as number],
                          {},
                        ),
                        'url',
                        null,
                      ),
                    )
                  ) {
                    props.setIncomeCertificates({
                      ...props.incomeCertificates,
                      [(props.victim.id as unknown) as number]: {
                        ...props.incomeCertificates[
                          (props.victim.id as unknown) as number
                        ],
                        type: e.target.value,
                      },
                    });
                  }
                  setDocumentType(e.target.value as any);
                }}
              >
                <MenuItem value={DOCUMENT_TYPES.INCOME_CERTIFICATE}>
                  {DOCUMENT_TYPES.INCOME_CERTIFICATE}
                </MenuItem>
                <MenuItem value={DOCUMENT_TYPES.SCHOOLING_CERTIFICATE}>
                  {DOCUMENT_TYPES.SCHOOLING_CERTIFICATE}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <TextField
              label={translate({ ...messages.income }, props)}
              name={INCOME_CERTIFICATE.INCOME}
              value={get(
                props.incomeCertificates[
                  (props.victim.id as unknown) as number
                ],
                INCOME_CERTIFICATE.INCOME,
                null,
              )}
              onChange={props.handleChange(props.victim)}
              type="number"
              InputLabelProps={{
                shrink: !isNil(
                  get(
                    props.incomeCertificates[
                      (props.victim.id as unknown) as number
                    ],
                    INCOME_CERTIFICATE.INCOME,
                    null,
                  ),
                ),
              }}
              error={
                get(
                  props.incomeCertificates[
                    (props.victim.id as unknown) as number
                  ],
                  INCOME_CERTIFICATE.INCOME,
                  null,
                ) && get(message, INCOME_CERTIFICATE.INCOME)
              }
              helperText={
                get(
                  props.incomeCertificates[
                    (props.victim.id as unknown) as number
                  ],
                  INCOME_CERTIFICATE.INCOME,
                  null,
                ) && get(message, INCOME_CERTIFICATE.INCOME)
              }
            />
          </Grid>

          <Grid item xs={3}>
            <UploadDocumentBloc
              document={get(
                props.incomeCertificates,
                [(props.victim.id as unknown) as number],
                {},
              )}
              setDocument={props.setDocument(props.victim.id)}
              index={props.index}
              resetUploadedDocument={props.resetUploadedDocument}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              docType={documentType as any}
              setDocumentId={props.setDocumentId}
              docId={(props.victim.id as unknown) as string}
              deleteDoc={() =>
                props.setIncomeCertificates({
                  ...props.incomeCertificates,
                  [(props.victim.id as unknown) as number]: {
                    ...props.incomeCertificates[
                      (props.victim.id as unknown) as number
                    ],
                    ...EMPTY_DOCUMENT_CERTIFICATE,
                  },
                })
              }
            />
          </Grid>
        </React.Fragment>
      )}
    </Grid>
  );
};

export default injectIntl(VictimCertificateForm);
